import TooltipLayout from "@/components/atoms/tooltip-layout/index.vue";
import { camelCase } from "lodash";
import moment from "moment";
import { seo } from "@/mixins/seo";

import VisaIcon from "@/assets/img/visa-card.png";
import MastercardIcon from "@/assets/img/mastercard-card.png";

import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
	name        : "profile-payments",
	mixins      : [seo],
	data() {
		return {
			defaultLoader   : false,
			replaceLoader   : false,
			deleteLoader    : false
		};
	},
	components  : {
		TooltipLayout,
	},
	created() {
		this.seo.title = this.$t(camelCase(this.$route.name));
		
		this.fetchCardsList();
	},
	computed: {
		...mapGetters({
			user                : 'user/user',
			provider            : "userPayments/provider",
			cardsList           : "userPayments/cardsList",
			isCardsListLoading  : "userPayments/isCardsListLoading"
		}),
	},
	methods: {
		...mapActions({
			fetchCardsList              : "userPayments/GET_CARDS_LIST",
			setDefaultCard              : "userPayments/SET_DEFAULT_PAYMENT_METHOD",
			setNewPaymentsMethod        : "userPayments/SET_NEW_PAYMENTS_METHOD",
			replacePaymentsMethod       : "userPayments/REPLACE_PAYMENTS_METHOD"
		}),
		...mapMutations({
			changeShowPopupDeleteCard   : "userPayments/CHANGE_POPUP_DELETE_CARD"
		}),
		normalizedCardType(item) {
			if (item === "mastercard") {
				return MastercardIcon;
			}
			
			if (item === "visa") {
				return VisaIcon;
			}
		},
		getItemDate(date, item) {
			if (!date) {
				return "";
			}
			
			let arr = date.split(" ");
			
			return moment(arr[0]).format("DD.MM.YY");
		},
		deleteCurrentCard(data) {
			this.changeShowPopupDeleteCard([true, data]);
		},
		async addNewCard() {
			if (this.provider != "fondy" && this.provider != "monobank") {
				this.$router.push({
					name: "profile-payment-methods-add",
				});
				
				return false;
			}
			
			try {
				const response = await this.setNewPaymentsMethod();
				
				if (response) {
					window.location = response.data.url;
				}
			} catch (error) {
				console.error("error", error);
				
				console.log("***", error.response.data);
				
				if (error.response.status === 400) {
					this.$toasted.error(error.response.data.message);
				}
			}
		},
		async setDefaultCurrentCard(item) {
			this.defaultLoader = true;
			
			try {
				var el = document.getElementsByClassName("profile-payments__head");
				
				if(el && el.length){
					el[0].click();
				}
			} catch (error) {
				console.error("error", error);
				
				this.defaultLoader = false;
				
				return;
			}
			
			try {
				await this.setDefaultCard(item.id);
			} catch (error) {
				console.error("error", error);
				
				this.defaultLoader = false;
				
				return;
			}
			
			this.$toasted.success(this.$t("successSetDefaultCard"));
			
			try {
				this.fetchCardsList();
			} catch (error) {
				console.error("error", error);
				
				//if (error.response.status === 422) {
				//    this.$toasted.error(error.response.data.validation.number);
				//}
			}
			
			this.defaultLoader = false;
		},
		async replaceCurrentCard(item) {
			this.replaceLoader = true;
			
			console.log("replaceCurrentCard:");
			console.log(item);
			
			try {
				const response = await this.replacePaymentsMethod(item.id);
				
				console.log("response:");
				console.log(response);
				
				if (response) {
					window.location = response.data.url;
				}else{
					this.replaceLoader = false;
				}
			} catch (error) {
				console.error("error", error);
				
				console.log("***", error.response.data);
				
				this.replaceLoader = false;
				
				if (error.response.status === 400) {
					this.$toasted.error(error.response.data.message);
				}
			}
		}
	}
};
